module.exports = __webpack_public_path__ + "res/Roboto-Thin-webfont.ttf?b08978116950f67fe3e1406e92405584";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/roboto/Roboto-Thin-webfont.ttf
// module id = 59
// module chunks = 0